import { useNavigate, useSearchParams } from 'react-router-dom';

import React, { useEffect, useState } from 'react';
import ButtonAdd from 'components/Global/ButtonAdd';
import Tabs, { TabPane } from 'components/Global/Tabs';
import DriverList from './DriverList';
import DriverTaskList from './DriverTaskList';
import WithdrawList from './WithdrawList';
import { useDispatch, useSelector } from 'react-redux';
import { resetSelectedDriver } from 'features/drivers/slice';
import DriverVerification from './DriverVerification';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';

const DriverComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.profile);

  const isDriverVerificationEnabled = useFliptBoolean(
    'FLAG_FE_DRIVER_ADMIN_VERIFICATION',
    false,
    user.id || 'anonymous',
  );

  const [activeTab, setActiveTab] = useState('');

  const [searchParams, setSearchParams] = useSearchParams();

  const tabActive = searchParams.get('tab-active');

  const handleAdd = () => {
    dispatch(resetSelectedDriver());
    navigate('/driver/add-driver');
  };

  const renderTabs = () => {
    const content = [
      { label: 'Driver', component: <DriverList /> },
      { label: 'Driver Task', component: <DriverTaskList /> },
      { label: 'Withdraw', component: <WithdrawList /> },
    ];

    if (isDriverVerificationEnabled) {
      content.push({ label: 'Verifikasi Driver Baru', component: <DriverVerification /> });
    }

    return content.map((item) => (
      <TabPane label={item.label} key={item.label}>
        {item.component}
      </TabPane>
    ));
  };

  useEffect(() => {
    if (!tabActive) {
      setSearchParams({ 'tab-active': 'Driver' });
    } else {
      setActiveTab(tabActive);
    }
  }, [tabActive]);

  return (
    <div className="driver">
      {tabActive === 'Driver' && <ButtonAdd onClick={handleAdd} label={`Tambah ${activeTab}`} />}

      <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
        {renderTabs()}
      </Tabs>
    </div>
  );
};

export default DriverComponent;
